import './utils/instrument';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import './tailwind.css';

import { loadLocale } from './i18n/intl/intl';
import Providers from './providers';
import { initPostHog, isPostHogEnabled } from './utils/posthog';
import { safeGetItem } from './utils/safeStorage';
import { store } from './utils/store';

initPostHog();

const raw = safeGetItem('lang');
const lang = JSON.parse(raw ?? 'null');
if (lang?.code && lang.code !== 'en') {
  await loadLocale(lang.code);
}

const { default: App } = await import('./App');

const appTree = (
  <Provider store={store}>
    <Providers>
      <App />
    </Providers>
  </Provider>
);

const wrappedAppTree = isPostHogEnabled() ? (
  <PostHogProvider client={posthog}>{appTree}</PostHogProvider>
) : (
  appTree
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.VITE_NODE_ENV === 'production' ? (
    wrappedAppTree
  ) : (
    <React.StrictMode>{wrappedAppTree}</React.StrictMode>
  ),
);
